import { FC } from 'react'
import { Advisor } from 'components/features/coaching/advisor/types/advisor'

type AdvisorGradesProps = {
  advisor: Advisor
}
export const AdvisorGrades: FC<AdvisorGradesProps> = (props) => {
  const { advisor } = props

  const {
    company,
    certificates,
    certifications_other,
  } = advisor

  const certs = [...certificates, certifications_other].filter(Boolean).join(', ')
  const companyChild = !company ? null : (
    <span>
      { company }
    </span>
  )

  if (certs && companyChild) {
    return (
      <>
        { certs }
        <span> | { companyChild }</span>
      </>
    )
  }

  if (certs) {
    return (
      <>
        { certs }
      </>
    )
  }

  if (companyChild) {
    return (
      <span>
        { companyChild }
      </span>
    )
  }

  return null
}
